<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    <div [class.duplicate-item-wrapper]="duplicateBooking">
      @if (duplicateBooking) {
        <div class="duplicate-item-date">
          <i class="ico-taxi"></i>&nbsp;
          @if (taxi?.detail?.departs; as departs) {
            <span i18n="@@itineraryCarPickUpDatetime">Pick-up:</span>
            <strong>{{ departs | sabsDate: 5 }}</strong>
          }
        </div>
      }
      <div [class.duplicate-item-info]="duplicateBooking">
        <div class="cart_item_heading">
          @if (!duplicateBooking) {
            <i class="ico-taxi"></i>&nbsp;
          }
          <strong>{{ taxi?.detail?.vehicleType || taxi?.detail?.supplierName }}</strong>
          @if (!duplicateBooking) {
            <section (mouseleave)="tt1.close()">
              <button
                class="cart_item_remove ico-trash"
                ngbTooltip="Remove {{
                  taxi?.detail?.vehicleType || taxi?.detail?.supplierName
                }} taxi from your {{ (displayItinerary ? 'itinerary' : 'basket') | translate }}"
                attr.aria-label="Remove {{
                  taxi?.detail?.vehicleType || taxi?.detail?.supplierName
                }} taxi from your {{ (displayItinerary ? 'itinerary' : 'basket') | translate }}"
                i18n-aria-label
                i18n-ngbTooltip
                (click)="remove.emit()"
                triggers="manual"
                #tt1="ngbTooltip"
                (mouseenter)="tt1.open()"
                (focus)="tt1.open()"
                (blur)="tt1.close()"
                id="remove-basketitem-{{ taxi.id }}"
              ></button>
            </section>
          }
          @if (!duplicateBooking) {
            <section (mouseleave)="tt2.close()">
              <img
                src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                  displayItinerary ? 'luggage_icon' : 'basket_move'
                }}.svg"
                class="move_basket_icon"
                role="button"
                ngbTooltip="Move to different {{
                  (displayItinerary ? 'itinerary' : 'basket') | translate
                }}"
                i18n-ngbTooltip
                attr.aria-label="Move {{
                  taxi?.detail?.vehicleType || taxi?.detail?.supplierName
                }} taxi to different {{ (displayItinerary ? 'itinerary' : 'basket') | translate }}"
                i18n-aria-label
                (click)="openChangeModal.emit()"
                (keydown.enter)="openChangeModal.emit()"
                (keydown.space)="openChangeModal.emit()"
                triggers="manual"
                #tt2="ngbTooltip"
                (mouseenter)="tt2.open()"
                (focus)="tt2.open()"
                (blur)="tt2.close()"
                tabindex="0"
                id="share-basketitem-{{ taxi.id }}"
              />
            </section>
          }
        </div>
        @if (taxi?.detail?.fromLocation; as fromLocation) {
          <div class="location-container">
            <span i18n="@@itineraryCabFromLocation">Pick-up location:</span>
            <app-taxi-location [location]="fromLocation"></app-taxi-location>
          </div>
        }
        @if (!duplicateBooking && taxi?.detail?.departs; as departs) {
          <div class="cart_item_taxi_detail">
            <span i18n="@@basketPanelTaxiPickUp">Pick-up:</span> {{ departs | sabsDate: 5 }}
          </div>
        }
        @if (taxi?.detail?.toLocation; as toLocation) {
          <div class="location-container location-container--drop-off">
            <span i18n="@@basketPanelTaxiDropOffLocation">Drop-off location:</span>
            <app-taxi-location [location]="toLocation"></app-taxi-location>
          </div>
        }
        @if (taxi?.detail?.vias?.length) {
          <div class="cart_item_taxi_detail flex-row-container">
            <span i18n="@@taxiVia">Via:&nbsp;</span>
            <span>
              @for (via of taxi.detail.vias; track via; let last = $last) {
                <app-taxi-location [isVia]="true" [location]="via"></app-taxi-location>
              }
            </span>
          </div>
        }
        @if (taxi?.detail?.supplierName) {
          <div class="cart_item_taxi_detail">
            <span i18n="@@itineraryVendor">Vendor:</span> {{ taxi.detail.supplierName }}
          </div>
        }
      </div>
    </div>

    <div class="car_cart_item_to_point"></div>
    @if (!duplicateBooking) {
      @for (user of travellers; track user) {
        <div class="traveller-name">
          <b>{{ user.forename }}, {{ user.surname }}</b>
        </div>
      }
    }
    <div class="cart_item_price">
      @if (duplicateBooking) {
        <strong i18n="@@basketPanelTaxiCost">Cost</strong>
      }
      <strong>{{ taxi.price | currency: taxi.currency }}</strong>
      @if (!duplicateBooking) {
        <em i18n="@@basketPanelTaxiTotalPrice">&nbsp;Total Price (Excl VAT)</em>
      }
    </div>
  </div>
</div>
